import "./comments.scss";
import { useComments } from "./hooks/useComments";
import CommentInput from "./components/CommentInput";
import CommentList from "./components/CommentList";

const Comments = ({ postId }) => {
    const { 
        currentUser,
        desc, 
        setDesc, 
        handleClick, 
        isLoading, 
        error, 
        rootComments, 
        isSending,
        cooldown,
        queryClient
    } = useComments(postId);

    return (
        <div className="comments">
            <CommentInput 
                currentUser={currentUser}
                desc={desc}
                setDesc={setDesc}
                onSubmit={handleClick}
                isSending={isSending}
                cooldown={cooldown}
            />

            <CommentList 
                isLoading={isLoading}
                error={error}
                rootComments={rootComments}
                queryClient={queryClient}
                currentUser={currentUser}
                postId={postId}
            />
        </div>
    );
};

export default Comments;